// Mapping UI pour l'ENUM ventes.type_caisse
// L'ENUM DB reste : 'officielle', 'instance', 'noir'
// §201 06/06/2026 : CENTRAL_ROLES = {'admin'} (cf middleware/auth.py backend)

export const TYPE_CAISSE_LABELS = {
  officielle: 'Caisse',
  instance: 'En instance',
  noir: 'BL',
};

export const TYPE_CAISSE_OPTIONS = [
  { value: 'officielle', label: 'Caisse' },
  { value: 'instance', label: 'En instance' },
  { value: 'noir', label: 'BL' },
];

export function getTypeCaisseLabel(value) {
  if (!value) return '';
  return TYPE_CAISSE_LABELS[value] ?? value;
}

// §201 — Classes de teinte (bg/text/border) pour différencier discrètement le
// type_caisse dans les listes. Volontairement SOBRE : nuances de gris + ambre
// très pâle, repérable à l'usage sans être criard. Pas de rouge ni couleur vive.
// Ne renvoie que les couleurs — chaque rendu garde son propre padding/rounded.
const TYPE_CAISSE_BADGE_CLASSES = {
  officielle: 'bg-slate-100 text-slate-700 border-slate-200', // neutre (défaut)
  noir:       'bg-gray-200 text-gray-600 border-gray-300',    // grisé plus marqué + assombri
  instance:   'bg-amber-50 text-amber-700 border-amber-200',  // entre-deux, ambre très pâle
};

export function getTypeCaisseBadgeClass(value) {
  return TYPE_CAISSE_BADGE_CLASSES[value] ?? TYPE_CAISSE_BADGE_CLASSES.officielle;
}

// CENTRAL = admin uniquement (synchro avec backend middleware.auth.CENTRAL_ROLES)
// Si on ajoute un rôle 'gerant' à l'ENUM DB un jour, l'ajouter ici aussi.
const CENTRAL_ROLES = ['admin'];

export function isCentralRole(role) {
  return CENTRAL_ROLES.includes(role);
}

// Helper pour determiner si l'utilisateur peut voir le selecteur type_caisse
export function canSeeTypeCaisse(role) {
  return isCentralRole(role);
}

// Helper pour determiner si l'utilisateur peut editer une vente
export function canEditVente(role) {
  return isCentralRole(role);
}

// §205 — Vendeuse (rôle 'boutique') : ne doit JAMAIS voir coût/marge/OF/fiche
// fabrication. On cible explicitement 'boutique' (et PAS isCentralRole inversé)
// car l'atelier/chef_atelier DOIT légitimement voir les OF et fiches de fab.
// Toujours évaluer sur user.role (localStorage 'user'), JAMAIS sur
// workspaceContext.type (un admin peut basculer en contexte boutique).
export function isVendeuse(role) {
  return role === 'boutique';
}
